import React, { FC, useState } from 'react';
import { makeStyles } from 'tss-react/mui';
import Typography from '@mui/material/Typography';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';

import { 
  AccountGroupWithAccess,
} from 'companion-app-components/flux/account-groups/accountGroupsTypes';

import AccessTypeModal from './AccessTypeModal';
import { styles } from './styles';

const useStyles = makeStyles()(styles as Record<string, any>);

interface AccessTypesProps {
  fullAccess: boolean;
  handleFullAccessChange: (event) => void;
  accountGroups: AccountGroupWithAccess[];
}

const AccessTypes: FC<AccessTypesProps> = ({ fullAccess, handleFullAccessChange, accountGroups }) => {

  const { classes } = useStyles();

  const [showAccessTypeModal, setShowAccessTypeModal] = useState(false);

  const handleHelpClick = () => {
    setShowAccessTypeModal(!showAccessTypeModal);
  };

  return (
    <>
      <div className={classes.accessDivWrapper}>
        <Typography variant="caption" sx={{ mb: 1, display: 'block' }}>
          Access Type <HelpOutlineIcon sx={{ fontSize: 16, cursor: 'pointer' }} onClick={handleHelpClick} />
        </Typography>
        <Typography gutterBottom variant="body2">
          How would you like to share your dataset?
        </Typography>
        <div>
          <RadioGroup value={fullAccess} onChange={handleFullAccessChange}>
            <FormControlLabel value label="Grant full access to the entire dataset" control={<Radio />} />
            <FormControlLabel value={false} disabled={accountGroups.length === 0} label="Share custom access (specific entities only)" control={<Radio />} />
          </RadioGroup>
        </div>
      </div>
      <AccessTypeModal handleClose={handleHelpClick} open={showAccessTypeModal} />
    </>
  );
};

export default AccessTypes;
